// extracted by mini-css-extract-plugin
export default {"content":"styles_content__Fpz9F","title":"styles_title__OB1Y0","subtitle":"styles_subtitle__cLAFU","disclaimer":"styles_disclaimer__-+ctt"};